import { render } from "./BlockNomeFantasia.vue?vue&type=template&id=7e666576"
import script from "./BlockNomeFantasia.vue?vue&type=script&lang=js"
export * from "./BlockNomeFantasia.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CampoForm/components/BlockNomeFantasia.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e666576"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e666576', __exports__)) {
    console.log('reload')
    api.reload('7e666576', __exports__)
  }
  
  module.hot.accept("./BlockNomeFantasia.vue?vue&type=template&id=7e666576", () => {
    console.log('re-render')
    api.rerender('7e666576', render)
  })

}


export default __exports__